// extracted by mini-css-extract-plugin
export var highlightFade = "_26-4";
export var highlighted = "_26-3";
export var table = "_26-1";
export var tableContainer = "_26-0";
export var totalsRow = "_26-2";